var AnimationSetBase = (function () {
    function AnimationSetBase() {
    }
    return AnimationSetBase;
}());
export { AnimationSetBase };
